import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import Features from './components/Features';
import Reviews from './components/Reviews';
import SEOContent from './components/SEOContent';
import CTA from './components/CTA';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: 'OOPBUY Spreadsheet',
      url: SITE_URL,
      description: 'OOPBUY Spreadsheet ist deine All-in-One Lösung für internationales Shopping. Vergleiche Preise, prüfe Qualität und spare mit dem OOPBUY Spreadsheet.',
      inLanguage: 'de',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${SITE_URL}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: 'OOPBUY Spreadsheet',
      url: SITE_URL,
      description: 'OOPBUY Spreadsheet – Der ultimative Guide für smartes Shopping in Deutschland, Österreich und der Schweiz.',
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <Features />
        <Reviews />
        <SEOContent />
        <CTA />
      </main>
      <Footer />
    </>
  );
}